import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Hand } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Empty, PageHeader } from "@/components/PageHeader";
import { ShiftCard } from "@/pages/staff/StaffHome";
import { api, errMsg } from "@/lib/api";

export default function OpenShifts() {
  const [rows, setRows] = useState([]);
  const [instant, setInstant] = useState(false);
  const load = useCallback(() => {
    api.get("/me/open-shifts").then((r) => setRows(r.data));
  }, []);
  useEffect(() => {
    load();
    api.get("/me/rota-view").then((r) => setInstant(r.data.claim_mode === "instant")).catch(() => {});
  }, [load]);

  const claim = async (id) => {
    try {
      const { data } = await api.post("/me/requests", { type: "claim", shift_id: id });
      toast.success(data.instant ? "It's yours! The shift has been added to your rota" : "Claim sent. Your manager will confirm");
      load();
    } catch (e) {
      toast.error(errMsg(e));
      load();
    }
  };

  return (
    <div className="mx-auto max-w-2xl">
      <PageHeader title="Open shifts" subtitle={instant ? "First to claim gets the shift. No waiting for approval" : "Pick up extra hours. Your manager confirms each claim"} />
      {rows.length === 0 ? <Empty testId="open-shifts-empty">No open shifts right now.</Empty> : (
        <div className="space-y-3">
          {rows.map((s) => (
            <ShiftCard key={s.id} s={s} action={
              <Button size="sm" className="rounded-full bg-amber-500 text-slate-950 hover:bg-amber-400" disabled={s.claimed_by_me} onClick={() => claim(s.id)} data-testid={`claim-shift-btn-${s.id}`}>
                <Hand className="mr-1 h-4 w-4" />{s.claimed_by_me ? "Claim pending" : instant ? "Take this shift" : "Claim shift"}
              </Button>
            } />
          ))}
        </div>
      )}
    </div>
  );
}
